export default __webpack_public_path__ + "static/media/Copy of Get-Quarterly-Scans.5640c34f.jpg";